module.exports = __webpack_public_path__ + "img/Picture4.bc4024b1.jpg";